<template>
    <div class="format-picker-section">
        <div class="sectionTitle">{{ title }}</div>
        <a-popover :visible="visible" :overlayClassName="'no-padding'" @visibleChange="(_visible) => (visible = false)">
            <div slot="content">
                <DateFormatPicker v-model="clone" />
            </div>
            <div class="entity-input">
                <div class="entity-input-text-wrapper">
                    <TiptapEditor
                        :placeholder="title"
                        :show-attributes="true"
                        :show-emoji="false"
                        v-model="clone"
                        :key="clone"
                        automation-mode
                    />
                </div>
                <span class="material-icons" @click="visible = !visible"> expand_more </span>
            </div>
        </a-popover>
    </div>
</template>

<script>
import _ from "lodash";
import log2 from "../../../../../../../../../utils/log2";
import TiptapEditor from "../../../../../../../Chatbot/pages/dashboard/common/TiptapEditor.vue";
import DateFormatPicker from "../../../../pickers/DateFormatPicker.vue";

const log = log2("FormatPickerInput.vue");
export default {
    name: "FormatPickerInput.vue",
    components: { DateFormatPicker, TiptapEditor },
    props: {
        value: {
            type: String,
        },
        title: {
            type: String,
            default: "Select Format",
        },
    },
    data() {
        const clone = _.cloneDeep(this.value);
        return {
            clone,
            visible: false,
        };
    },
    methods: {},
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.visible = false;
                this.$emit("input", newValue);
            },
        },
        value(newValue) {
            if (_.isEqual(newValue, this.clone)) return;
            this.clone = _.cloneDeep(newValue);
        },
    },
};
</script>

<style lang="scss" scoped>
.format-picker-section {
    .sectionTitle {
        margin-bottom: 10px;
        margin-top: 15px;
        color: #22272d;
        font-weight: 600;
        font-size: 16px;
        line-height: 20px;
    }

    .entity-input {
        align-items: center;
        background: #fff;
        border: 1px solid #c6cdd4;
        border-radius: 6px;
        cursor: pointer;
        display: flex;
        height: 43px;
        padding: 15px;
        position: relative;
        transition: all 0.3s;
        user-select: none;
        width: 100%;
        margin-top: 10px;

        &:hover {
            border: 1px solid #006cff !important;
        }

        .entity-input-text-wrapper {
            display: flex;
            flex-grow: 1;
            width: 0;
        }

        .entity-input-placeholder {
            color: #9ba6b3;
            font-size: 15px;
            line-height: 19px;
            overflow: hidden !important;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        .single-entity-style {
            background: #ffdc66;
            cursor: pointer;
            transition: all 0.3s;
            border-radius: 10px;
            box-decoration-break: clone;
            padding: 0 8px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-weight: 800;

            &.active {
                background: #006cff;
                color: #fff;

                .material-icons {
                    color: #fff;
                }
            }

            .material-icons {
                color: #647283;
                font-size: 18px;
                margin-right: 3px;
            }
        }
    }
}
</style>
